<vectronic-card [title]="title()" [displayClose]="true" (closed)="close()">
  <ng-container body>
    <div
      class="activate-airtimes__dialog-body"
      [class.activate-airtimes__dialog-body--loading]="isLoading()"
    >
      @if (isLoading()) {
        <div class="activate-airtimes__loading-overlay">
          <mat-spinner diameter="40"></mat-spinner>
        </div>
      }

      @if (isSingleSelection()) {
        <div class="activate-airtimes__single-msg">
          <div class="activate-airtimes__single-header">
            {{ showDeactivate() ? singleDeactivationHeader() : singleActivationHeader() }}
          </div>
          <div class="activate-airtimes__single-info">
            {{ showDeactivate() ? singleDeactivationInfo() : singleActivationInfo() }}
          </div>
          @if (!showDeactivate()) {
            <div class="activate-airtimes__single-info">
              {{ singleActivationGlobalstar() }}
            </div>
          }
        </div>
      } @else {
        <div class="activate-airtimes__device-ids">
          <strong> Manage Network Status for Device id(s): </strong>
          {{ deviceIdsLabel() }}
        </div>
        <table-datatable
          [datatableConfig]="planTableConfig"
          [data]="planSummaryRows()"
        ></table-datatable>
      }

      @if (errorMessage()) {
        <div class="activate-airtimes__error">
          {{ errorMessage() }}
        </div>
      }
    </div>

    <div class="activate-airtimes__actions">
      <button mat-button (click)="close()" [disabled]="isLoading()">
        <mat-icon color="warn">cancel</mat-icon>
        Cancel
      </button>
      @if (showActivate() && showDeactivate()) {
        <mat-form-field appearance="outline">
          <mat-label>Network Status</mat-label>
          <mat-select [disabled]="isLoading()" [(value)]="selectedAction">
            <mat-option [value]="'activate'">
              <mat-icon color="accent">wifi</mat-icon>
              <span>Activate</span>
            </mat-option>
            <mat-option [value]="'deactivate'">
              <mat-icon color="warn">wifi_off</mat-icon>
              <span>Deactivate</span>
            </mat-option>
          </mat-select>
        </mat-form-field>
        <button mat-button (click)="submitSelected()" [disabled]="!canSubmit()">
          <mat-icon color="accent">check</mat-icon>
          {{
            selectedAction() === 'deactivate'
              ? allGsmSelection()
                ? 'Deactivate Permanently'
                : 'Deactivate'
              : 'Activate'
          }}
        </button>
      } @else if (showActivate()) {
        <button mat-button (click)="onActivate()" [disabled]="isLoading()">
          <mat-icon color="accent">wifi</mat-icon>
          {{ isLoading() ? 'Activating...' : 'Activate' }}
        </button>
      } @else if (showDeactivate()) {
        <button mat-button (click)="onDeactivate()" [disabled]="isLoading()">
          <mat-icon color="warn">wifi_off</mat-icon>
          {{
            isLoading()
              ? 'Deactivating...'
              : allGsmSelection()
                ? 'Deactivate Permanently'
                : 'Deactivate'
          }}
        </button>
      }
    </div>
    @if (showGsmDeactivationWarning()) {
      <div class="activate-airtimes__warning">
        Once deactivated the GSM service can not be reactivated
      </div>
    }
  </ng-container>
</vectronic-card>
